import SectionHeading from '@/pages/home/components/SectionHeading';
import { timeline } from '@/mocks/home';

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="事件脉络"
          title="从时间线看关系如何形成"
          desc="按时间顺序把关键节点串起来，看清圈内关系是在哪一步开始变得复杂。"
        />

        <ol className="mt-8 flex flex-col">
          {timeline.map((item, index) => (
            <li key={item.title} className="relative flex gap-4 pb-8 last:pb-0 md:gap-6">
              <div className="flex flex-col items-center">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-primary-50 font-label text-xs font-semibold text-primary-700">
                  {index + 1}
                </span>
                {index < timeline.length - 1 && <span className="mt-1 w-px flex-1 bg-background-300" />}
              </div>
              <div className="flex-1 pt-1">
                <span className="font-label text-xs tracking-wide text-accent-700">{item.date}</span>
                <h4 className="mt-1 font-heading text-base font-semibold text-foreground-950">{item.title}</h4>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}